import styled from "styled-components";
import { ReactComponent as IconArrow } from "../../../styles/assets/svg/icon_backArrow.svg";
import { ReactComponent as IconSetting } from "../../../styles/assets/svg/icon_setting.svg";

interface conHeaderProps {
  title: string;
  onClickArrow: () => void;
  onClickSetting?: () => void;
  setIcon?: boolean;
}
const ConHeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
`;
// 공통 스타일
export const titleText = {
  fontSize: 16,
  fontWeight: 700,
  lineHeight: "24px",
  color: "var(--neutral-700, #404040)",
};

export const ConHeader = ({
  title,
  onClickArrow,
  onClickSetting,
  setIcon,
}: conHeaderProps) => {
  return (
    <ConHeaderBox>
      <IconArrow onClick={onClickArrow} style={{ cursor: "pointer" }} />
      <div style={{ ...titleText, color: "white" }}>{title}</div>
      {setIcon ? (
        <IconSetting onClick={onClickSetting} style={{ cursor: "pointer" }} />
      ) : (
        <div style={{ width: 24, height: 24 }} />
      )}
    </ConHeaderBox>
  );
};
